$(function() {
    // Case Study - Incontent Accordion

    $('.accordion-link').on('click', function(e) {
        e.preventDefault();

        var $this = $(this);

        $this.toggleClass('open');
        $this.siblings('.accordion-content').toggle();
    });

    // Cloud VPS - Benchmarks

    $('.rows .overview').on('click', function(event) {
        let $this = $(this);
        let $thisObject = $this.closest('.rows');
        let $activated = $thisObject.find('.benchmark').hasClass('active');

        if ($activated == true) {
            $thisObject.find('.benchmark').slideUp('slow');
        } else {
            let currentlyDownRow = $thisObject.closest('.table').find('.rows.active');

            if (currentlyDownRow.length) {
                currentlyDownRow.find('.benchmark').slideUp('slow');
                currentlyDownRow.removeClass('active');
                currentlyDownRow.find('.benchmark').removeClass('active');
            }

            $thisObject.find('.benchmark').slideDown('slow');
        }

        $thisObject.toggleClass('active');
        $thisObject.find('.benchmark').toggleClass('active');
    });

    // Blog Index - toggle categories

    $('#toggleCategories').on('click', function(e) {
        e.preventDefault();

        var $this = $(this);

        $this.parent().toggleClass('opened');
    });
});